// extracted by mini-css-extract-plugin
module.exports = {"uploadImagesDialog":"styles_uploadImagesDialog__e1iFn","infoBox":"styles_infoBox__uw97O","saveButtonBox":"styles_saveButtonBox__29KE-"};